var moduleMap = {
	"./assets/localization/i18n": function() {
		return Promise.all([__webpack_require__.e(9375), __webpack_require__.e(8978), __webpack_require__.e(3968), __webpack_require__.e(2843), __webpack_require__.e(316), __webpack_require__.e(2853)]).then(function() { return function() { return (__webpack_require__(2853)); }; });
	},
	"./App": function() {
		return Promise.all([__webpack_require__.e(9355), __webpack_require__.e(8177)]).then(function() { return function() { return (__webpack_require__(8177)); }; });
	},
	"./main": function() {
		return __webpack_require__.e(3392).then(function() { return function() { return (__webpack_require__(3392)); }; });
	},
	"./setupServices": function() {
		return Promise.all([__webpack_require__.e(9375), __webpack_require__.e(6680), __webpack_require__.e(8978), __webpack_require__.e(3968), __webpack_require__.e(2843), __webpack_require__.e(316), __webpack_require__.e(2853), __webpack_require__.e(9487), __webpack_require__.e(9355), __webpack_require__.e(959)]).then(function() { return function() { return (__webpack_require__(959)); }; });
	},
	"./store/index": function() {
		return Promise.all([__webpack_require__.e(9375), __webpack_require__.e(8978), __webpack_require__.e(3968), __webpack_require__.e(2843), __webpack_require__.e(316), __webpack_require__.e(2853)]).then(function() { return function() { return (__webpack_require__(1037)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});